import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import HandIcon from '@swf/core/assets/icons/hand-icon.svg';
import { FeatureFlag } from '@swf/core/enums';
import { StatusCode } from '@swf/core/enums/statusCode';
import useFeature from '@swf/core/hooks/useFeature';
import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';

import { TXTWCL_24_hour_lockout } from './PanicButtonVegas.messages.json';
import styles from './PanicButtonVegas.scss';

const PanicButtonVegas: React.FC = () => {
  const request = useRequest();
  const submittingRef = useRef(false);
  const useRam1 = useFeature(FeatureFlag.UseRam1);

  const sendEventForRamSelfExclusion = () => {
    const event = new CustomEvent('openselfexcludese24', { bubbles: true, cancelable: true });
    document.dispatchEvent(event);
  };

  const { modal } = useDispatch<Dispatch>();

  const excludeFor24Hours = () => {
    if (submittingRef.current) return;

    submittingRef.current = true;
    request({
      service: 'responsiblegaming.panicbutton'
    }).subscribe(
      () => {
        submittingRef.current = false;
        modal.enqueue({ path: '/notifications/cooling-off-period' });
      },
      ({ headers: { statusCode } }) => {
        submittingRef.current = false;
        if (
          statusCode === StatusCode.ALREADY_SELF_EXCLUDED_ERROR ||
          statusCode === StatusCode.OBSOLETE_ERROR
        ) {
          modal.enqueue({ path: '/notifications/exclusion-info-vegas' });
        }
      }
    );
  };

  return (
    <div
      className={styles.panicButton}
      onClick={() => (useRam1 ? sendEventForRamSelfExclusion() : excludeFor24Hours())}
    >
      <HandIcon width={18} height={18} />
      <Translation {...TXTWCL_24_hour_lockout} />
    </div>
  );
};

export default PanicButtonVegas;
